import Axios from 'axios';
import { BASE_URL } from '../config/urls';

export class Upload {
  static uploadImage = (file: File) => {
    const data = new FormData();
    data.append('file', file);
    data.append('upload_preset', 'react-admin');
    return Axios.post(`${BASE_URL}/upload`, data).then((res) => res.data);
  };
}
